import ninegrid from "../index.js";
import { ngRow, ngData } from "./ngData.js";

export class ngDataManager
{	
	constructor (owner) {
		this.owner = owner;
		
		this.row		= new ngRow(this);
		this.data		= new ngData(owner, this);
		

		this.setDataSource = (ds) => {

			if (this.data) this.data.reset();
			
			this.pageCnt		= 25;
			
			this.rawRecords		= [];
			this.viewRecords	= [];//ds.slice(0, this.pageCnt);
			this.delRecords		= [];
			//this.originRecords	= JSON.parse (JSON.stringify(ds));
			
			this.viewRecords.touch		= () => { this.viewRecords.updateCnt = (this.viewRecords.updateCnt || 0) + 1; };
			this.viewRecords.rawIndex	= 0;
			this.viewRecords.setPageCnt	= (v) => { this.pageCnt = v; };

			
			this.viewRecords.reset		= () => {
				if (this.owner.view) this.owner.view.redraw();
			};
			
			this.viewRecords.resetV2 = () => {
				this.owner.view.redrawV2();
			};
			
			this.data.set(ds);
		};
		
		this.getRowState = (nRow) => {
			var nRow = parseInt(nRow);
			if (nRow >= this.data.count()) return;
		
			return this.data.__ng(nRow).rowState;
		}
		
		this.getRowPosition = () => {
			return this.row.at;
		};
		this.setRowPosition = (nRow) => {
			this.row.at = nRow;
			//this.scrollTo_V1(nRow);
		};
		
		this.pageUp = () => {
			if (this.owner.isFirstPage) return;
			
			var totalHeight = $(".ng-container-body", this.owner.body).height() - ($(".ng-container-body thead", this.owner.body).height() || 0) - ($(".ng-container-body tfoot", this.owner.body).height() || 0);
			totalHeight -= $(".ng-container-body tbody.fixed", this.owner.body).height();
			
			//var rowCount = 20;
			var h = 0;
			var row = this.viewRecords.rawIndex;
			while (h < totalHeight) {
				row --;
				for (var i = 0; i < this.owner.template.length; i++) {
					//h += this.owner.matrix.body.height(row * this.owner.template.length + i);
					var matrixRow = parseInt(row * this.owner.template.length + i);
					h += this.owner.matrix.getHeight(matrixRow);
				}
			}
			return this.scrollTo_V1(row + 1);
		};
		
		this.pageDown = () => {
			if (this.owner.isLastPage) return;
			
			if (!$("ng-vscrollbar", this.owner.body).is(":visible")) return;
			
			const row = parseInt(Array.from(this.owner.body.querySelectorAll(".ng-container-body tbody.bindable tr:not(.nodata)")).pop().dataset.row);

			return this.scrollTo_V1(row);
			
			//return this.scrollBy(this.viewRecords.length - 1);
		};
		
		
		
		
		this.scrollTo_V1 = (nRow) => {
			//this.owner.io.closeEditor();
	
			if (nRow < 0) nRow = 0;
			if (nRow >= this.rawRecords.length) nRow = this.rawRecords.length - 1;
			
			//if (this.owner.body.querySelector(`tbody.bindable tr[data-row="${nRow}"]`)) return;

			this.viewRecords.rawIndex = nRow;
			this.viewRecords.reset();
	
			//this.row.at = nRow;

			return (nRow <= 0 || nRow >= this.rawRecords.length - 1) ? false : true;
		};
		
		this.scrollToV2 = (nRow) => {
			
			//this.owner.io.closeEditor();

			if (nRow < 0) nRow = 0;
			if (nRow >= this.rawRecords.length) nRow = this.rawRecords.length - 1;
			
			

			this.viewRecords.rawIndex = nRow;
			this.viewRecords.resetV2();

			//this.row.at = nRow;

			return (nRow <= 0 || nRow >= this.rawRecords.length - 1) ? false : true;
		};
	
	
		this.exprFunction = (s) => {
			
			s = s.replaceAll("ninegrid.ROW.ORDER", ninegrid.ROW.ORDER);

			let args = '...args';
			let body = 'let [data, currow, all] = args; currow = Number(currow); return ' + s + ';';
			
			//console.log(s);

			return new Function(args, body);
			//return new Function('data', 'currow', 'return ' + s + ';');
		};
		
		this.exprFunction2 = (s) => {

			const fields = this.owner.fields.get().sort((a, b) => b.length - a.length);

			fields.forEach(v => {
				const idx = this.owner.fields.indexOf(v);
				// \b는 단어의 시작과 끝을 의미합니다.
				// data\.{v}\b 를 사용하면 data.AAA는 잡히지만 data.AAAA는 무시됩니다.
				const regex = v === 'v'
					? new RegExp(`data\\.v\\b(?![\\[])`, 'g') // 뒤에 [가 오지 않는 경우만 찾음
					: new RegExp(`data\\.${v}\\b`, 'g');

				s = s.replace(regex, `data.v[${idx}]`);
			});

			/**
			 * data.AAA
			 * data[this.owner.fields.indexOf("AAA")]
			 */
			let args = '...args';
			let body = 'let [data, currow, all] = args; currow = Number(currow); return ' + s + ';';
			
			return new Function(args, body);
			//return new Function('data', 'currow', 'return ' + s + ';');
		};
		
		/**
		this.parseExpr = (s, row) => {
	
			if (!this.rawRecords || !s) return null;
			
			if (s.endsWith(";")) s = s.substr(0, s.length - 1);
			
			var func = '"use strict"; var currow = @currow; var data = @data; return (' + s.replace("expr:", "") + ")";
	
	
			if (this.rawRecords.length > row) {
				for (var v in this.rawRecords[row]) {
					func = func.replaceAll(v, "'" + this.rawRecords[row][v] + "'");
				}
			}
					
			return Function (func.replace("@currow", row).replace("@data", JSON.stringify(this.rawRecords[row]))) ();
		}; */
		
		/** data */
		this.getColumn = (rowidx,colnm) => { return this.data.get(rowidx, colnm); }
		this.setColumn = (rowidx,colnm,v) => {
			rowidx = parseInt(rowidx);
			if (this.data.get(rowidx)[colnm] != v && this.data.get(rowidx).__ng.rowState != ninegrid.ROW_STATE.INSERT) {
				this.data.get(rowidx).__ng.rowState = ninegrid.ROW_STATE.UPDATE;
				this.data.onRowStateChanged();
			}
			this.setColumnSilent(rowidx,colnm,v);
		}
		this.setColumnSilent = (nRow,colNm,v) => {
	
			this.data.set(nRow,colNm,v);
		}
		
		/** Fixed Row */
		
		this.setDataSource([]);
		
		for (var s in this.row) { if (!["first","last","count","add","insert","move","delete"].includes(s)) this.data[s] = this.row[s]; }	// 함수 복사
	}
}


